<span class="icon" *ngIf="svgPath">
    <img [src]="svgPath" [alt]="name">
</span>